<template>
    <span class="overflow-hidden" :class="classes">
        <img
            alt="avatar"
            class="min-h-full min-w-full object-cover"
            :src="filePath"
            v-if="filePath"
        />
        <svg
            class="h-24 w-24 text-gray-400"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            stroke-width="1.5"
            v-else
        ><path
            d="M6.750 6.000 A5.250 5.250 0 1 0 17.250 6.000 A5.250 5.250 0 1 0 6.750 6.000 Z"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
        /><path
            d="M7.476,3.334A8.711,8.711,0,0,0,13.75,6,8.709,8.709,0,0,0,17.2,5.289"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
        /><path
            d="M2.25,23.25a9.75,9.75,0,0,1,19.5,0"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
        /><path
            d="M8.25,14.249V15a3.75,3.75,0,0,0,7.5,0v-.751"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
        /></svg>
    </span>
</template>

<script>
    export default {
        props: {
            customClass: {
                type: String,
                default: '',
            },
            size: {
                type: String,
                default: 'medium',
            },
            rounded: {
                type: Boolean,
                default: true,
            },
            avatar: {
                type: Boolean,
                default: true,
            },
            path: {
                type: [String, File],
                default: '',
            },
            file: {
                type: File,
            },
        },

        computed: {
            classesRounded() {
                if (this.rounded) {
                    return 'rounded-full';
                }

                return '';
            },

            classes() {
                if (this.customClass) {
                    return this.customClass;
                }

                if (this.size == 'small') {
                    return `${this.classesRounded} h-10 w-10`;
                }

                if (this.size == 'large') {
                    return `${this.classesRounded} h-15 w-15`;
                }

                return `${this.classesRounded} h-12 w-12`;
            },

            filePath() {
                if (this.path && typeof this.path == 'object') {
                    return URL.createObjectURL(this.path);
                }

                if (this.path) {
                    return this.path;
                }

                return null;
            },
        },
    };
</script>
